import ExpandLeftIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/ExpandLeft.js";
import ExpandRightIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/ExpandRight.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
const pagination = (tokens) => {
    var _a;
    const { component: { pagination, button }, semantic: { iconSize: iconSizes }, } = tokens;
    // find the same token in `iconSizes`
    const iconSizeKey = (_a = Object.entries(iconSizes).find(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ([_, value]) => value.value === pagination.button.icon.width.value)) === null || _a === void 0 ? void 0 : _a[0];
    return {
        MuiPagination: {
            styleOverrides: {
                ul: Object.assign({}, applyTokens(pagination.container)),
            },
        },
        MuiPaginationItem: {
            defaultProps: {
                components: {
                    previous: ExpandLeftIcon,
                    next: ExpandRightIcon,
                },
            },
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign(Object.assign({ margin: 0 }, applyTokens(pagination.button)), applyTokens(pagination.button.unselected.default)), { "&:not(.Mui-disabled, .MuiPaginationItem-ellipsis)": {
                        "&:hover": applyTokens(pagination.button.unselected.hover),
                        "&:active": applyTokens(pagination.button.unselected.active),
                    }, "&.Mui-selected": Object.assign(Object.assign({}, applyTokens(pagination.button.selected.default)), { "&:not(.Mui-disabled, .MuiPaginationItem-ellipsis)": {
                            "&:hover": applyTokens(pagination.button.selected.hover),
                            "&:active": applyTokens(pagination.button.selected.active),
                        } }), "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(pagination.button.unselected.disabled)), { "&.Mui-selected": applyTokens(pagination.button.selected.disabled) }), " > svg": Object.assign(Object.assign({}, applyTokens(pagination.button.icon)), { color: "inherit" }) }), (iconSizeKey && {
                    "--atlas-icon-size": iconSizeKey,
                })),
                page: {
                    width: "unset",
                    minWidth: pagination.button.width.value,
                    paddingLeft: button.medium.paddingLeft.value,
                    paddingRight: button.medium.paddingRight.value,
                },
            },
        },
    };
};
export default pagination;
//# sourceMappingURL=pagination.js.map